import type { BrowserProvider } from '@coti-io/coti-ethers';
import React from 'react';

import { TokenRowComponent } from './TokenRow';
import type { ImportedToken } from '../../../types/token';
import { TransferContainerMain } from '../styles';

type TokensTabContentProps = {
  tokens: ImportedToken[];
  userHasAESKey: boolean;
  userAESKey: string | null;
  getAESKey: () => void;
  provider: BrowserProvider;
  cotiBalance?: string;
  propAESKey?: string | null | undefined;
  onSelectToken: (token: ImportedToken) => void;
  isDecrypted: boolean;
  onToggleDecryption: () => void;
  balances: Record<string, string>;
};

export const TokensTabContent: React.FC<TokensTabContentProps> = React.memo(
  ({
    tokens,
    provider,
    cotiBalance,
    propAESKey,
    onSelectToken,
    isDecrypted,
    onToggleDecryption,
    balances,
  }) => (
    <TransferContainerMain>
      {tokens.map((token, index) => {
        const tokenKey = token.address || `coti-${token.symbol}`;
        const balanceKey = token.address || token.symbol;
        return (
          <TokenRowComponent
            key={tokenKey}
            token={token}
            index={index}
            provider={provider}
            cotiBalance={cotiBalance}
            propAESKey={propAESKey}
            onSelectToken={onSelectToken}
            isDecrypted={isDecrypted}
            onToggleDecryption={onToggleDecryption}
            tokenBalance={balances[balanceKey] || '0'}
          />
        );
      })}
    </TransferContainerMain>
  ),
);

TokensTabContent.displayName = 'TokensTabContent';
